import React, { Suspense } from "react";

// Carga diferida del Canvas de three.js (@react-three/fiber + three).
// TechGridBackground es un overlay PURAMENTE decorativo (Canvas transparente,
// position:absolute inset:0, pointer-events:none), por lo que un fallback
// transparente no provoca layout shift ni pierde contenido: la rejilla
// simplemente aparece cuando el chunk carga. Así three.js sale del bundle
// inicial y deja de bloquear el arranque en TODAS las páginas (lo monta
// CommonPageHeader, el hero del Home, el form de contacto y HomeTwoSingleFeature).
const RealTechGridBackground = React.lazy(() => import("./TechGridBackground"));

// Error boundary: si el WebGL no está disponible (prerender headless sin GPU,
// navegadores con WebGL deshabilitado), el Canvas de three.js lanza
// "Error creating WebGL context" y, sin esto, tumbaría TODO el árbol de React
// (página en blanco / body vacío en el prerender). Al ser decorativo, lo
// capturamos y renderizamos el fallback.
//
// OJO: en CommonPageHeader el grid NO es solo decorativo, es el único fondo
// que tiene la cabecera, y su <h1> es blanco. Sin fallback, un fallo de WebGL
// deja el título blanco sobre blanco (franja vacía de 500 px). Por eso quien
// dependa del grid para el contraste debe pasar `fallback`.
class CanvasErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch() {
    // Silencioso a propósito: el grid es decorativo.
  }
  render() {
    if (this.state.failed) return this.props.fallback || null;
    return this.props.children;
  }
}

const TechGridBackground = ({ fallback = null, ...props }) => (
  <CanvasErrorBoundary fallback={fallback}>
    <Suspense fallback={null}>
      <RealTechGridBackground {...props} />
    </Suspense>
  </CanvasErrorBoundary>
);

export default TechGridBackground;
